<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9 style="display: flex;">
        <h2 class="mr-4" style="align-self: center;">
          {{ $t('Egg Digital') }}
        </h2>
        <img style="height: 80px" src="/static/img/egg.png" />
      </v-flex>
    </v-layout>
    <div>
      {{ $t('Subscribe EggCRM Freemium Package From ZWIZ Website') }}
    </div>
    <div v-if="loading" class="text-xs-center">
      <div class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('Apply for EggCRM') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('Free connection to EggCRM service with more convenient service.') }}</div>
          <v-btn depressed color="primary" target="_blank" @click="showDialog = true">
            {{ $t('Join the Egg Digital') }}</v-btn
          >
          <v-dialog v-model="showDialog" persistent max-width="500">
            <v-card>
              <v-btn style="float: right;" fab small flat @click="showDialog = false">
                <v-icon>close</v-icon>
              </v-btn>

              <div class="text-xs-center pa-3">
                <span
                  style="    font-size: 20px;
    font-weight: bold;"
                  >{{ $t('Business Information') }}</span
                >
              </div>
              <v-card-text>
                <form>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('shopNameTh') }">
                    <label>{{ $t('Shop name(thai)') }}</label>
                    <input
                      :data-vv-as="$t('Shop name(thai)')"
                      v-validate="'required'"
                      v-model="registerData.merchantNameTH"
                      name="shopNameTh"
                      class="form-control"
                      type="text"
                    />
                    <span class="text-error" v-if="errors.has('shopNameTh')">{{
                      errors.first('shopNameTh')
                    }}</span>
                  </div>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('shopNameEn') }">
                    <label>{{ $t('Shop name(english)') }}</label>
                    <input
                      :data-vv-as="$t('Shop name(english)')"
                      v-validate="'required'"
                      v-model="registerData.merchantNameEN"
                      name="shopNameEn"
                      class="form-control"
                      type="text"
                    />
                    <span class="text-error" v-if="errors.has('shopNameEn')">{{
                      errors.first('shopNameEn')
                    }}</span>
                  </div>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('name') }">
                    <label>{{ $t('Name and Surname') }}</label>
                    <input
                      :data-vv-as="$t('Name and Surname')"
                      v-validate="'required'"
                      v-model="registerData.contactPerson"
                      name="name"
                      class="form-control"
                      type="text"
                    />
                    <span class="text-error" v-if="errors.has('name')">{{
                      errors.first('name')
                    }}</span>
                  </div>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('phone') }">
                    <label>{{ $t('Phone') }}</label>
                    <input
                      :data-vv-as="$t('Phone')"
                      v-validate="{ required: true, regex: /^([0]{1})([6,8,9]{1})([0-9]{8})$/ }"
                      v-model="registerData.phoneNumber"
                      class="form-control"
                      type="text"
                      name="phone"
                    />
                    <span class="text-error" v-if="errors.has('phone')">{{
                      errors.first('phone')
                    }}</span>
                  </div>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('email') }">
                    <label>{{ $t('Email') }}</label>
                    <input
                      :data-vv-as="$t('Email')"
                      v-validate="'required|email'"
                      v-model="registerData.email"
                      name="email"
                      class="form-control"
                      type="text"
                    />
                    <span class="text-error" v-if="errors.has('email')">{{
                      errors.first('email')
                    }}</span>
                  </div>
                  <div class="form-control" :class="{ 'has-error': errors.has('password') }">
                    <label>{{ $t('Password') }}</label>
                    <div>
                      <label
                        ><small>{{
                          $t(
                            'Password must be at least 8 characters long. And contain both uppercase letters Lowercase special characters and numbers'
                          )
                        }}</small></label
                      >
                    </div>

                    <input
                      v-validate="{
                        required: true,
                        min: 8,
                        regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/
                      }"
                      v-model="registerData.password"
                      name="password"
                      type="password"
                      :data-vv-as="$t('Password')"
                      autocomplete="on"
                      ref="password"
                    />
                    <span class="text-error" v-if="errors.has('password')">{{
                      errors.first('password')
                    }}</span>
                  </div>
                  <div class="form-control" :class="{ 'has-error': errors.has('passwordconfirm') }">
                    <label>{{ $t('Confirm password') }}</label>
                    <input
                      v-validate="'required|confirmed:password'"
                      name="passwordconfirm"
                      :data-vv-as="$t('Confirm password')"
                      type="password"
                      autocomplete="on"
                    />
                    <span class="text-error" v-if="errors.has('passwordconfirm')">{{
                      errors.first('passwordconfirm')
                    }}</span>
                  </div>
                </form>
                <v-checkbox v-model="submitCheckbox" color="primary" class="mt-0">
                  <template v-slot:label>
                    <v-dialog v-model="dialogPrivacyNotice" persistent width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <small>
                            {{ $t('agree')
                            }}<a v-bind="attrs" v-on="on"> {{ $t('Privacy Notice') }}</a></small
                          >
                          <v-dialog v-model="dialogTermAndCondition" persistent width="600px">
                            <template v-slot:activator="{ on, attrs }">
                              <small>
                                {{ $t('and agree')
                                }}<a v-bind="attrs" v-on="on">
                                  {{ $t('Terms and Condition') }}</a
                                ></small
                              >
                            </template>
                            <v-card>
                              <v-card-title>
                                <span>{{ $t('Terms and Condition') }}</span>
                              </v-card-title>
                              <v-card-text>
                                {{
                                  currentLang === 'th'
                                    ? term_and_condition.descriptionTh
                                    : term_and_condition.descriptionEn
                                }}
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outline
                                  text
                                  @click="dialogTermAndCondition = false"
                                >
                                  {{ $t('close') }}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </div>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span>{{ $t('Privacy Notice') }}</span>
                        </v-card-title>
                        <v-card-text>
                          {{
                            currentLang === 'th'
                              ? privacy_notice.descriptionTh
                              : privacy_notice.descriptionEn
                          }}
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" outline text @click="dialogPrivacyNotice = false">
                            {{ $t('close') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                </v-checkbox>
                <div name="footer" class="text-xs-center">
                  <v-btn
                    @click="submitRegister"
                    class
                    style="color:#ffffff"
                    color="primary"
                    :loading="loading"
                    :disabled="!submitCheckbox"
                    >{{ $t('Register') }}</v-btn
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <div>
            <!-- <a
              href="https://blog.zwiz.ai/%e0%b9%81%e0%b8%88%e0%b9%89%e0%b8%87%e0%b9%80%e0%b8%a5%e0%b8%82%e0%b8%9e%e0%b8%b1%e0%b8%aa%e0%b8%94%e0%b8%b8%e0%b8%96%e0%b8%b6%e0%b8%87%e0%b8%a5%e0%b8%b9%e0%b8%81%e0%b8%84%e0%b9%89%e0%b8%b2%e0%b9%84/"
              target="_blank"
              >ดูวิธีการใช้งานอย่างละเอียด</a
            > -->
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('Connect Zwiz to EggCRM.') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div class="mb-2" v-if="showCancel">
            <div>
              {{ $t('Enable / Disable EggCRM.') }}
            </div>
            <div>
              <toggle-button
                class="mt-2"
                :value="egg_status"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="toggleStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
            </div>
          </div>

          <v-btn depressed color="primary" target="_blank" :href="bypass_url">{{
            $t('Go to egg platform')
          }}</v-btn>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      submitCheckbox: false,
      dialogPrivacyNotice: false,
      dialogTermAndCondition: false,
      step: 1,
      showDialog: false,
      egg_status: false,
      loading: false,
      showCancel: true,
      registerData: {},
      bypass_url: '',
      privacy_notice: null,
      term_and_condition: null
    }
  },
  async mounted() {
    this.eggPageConfig()
    this.eggPrivacyNotice()
    this.eggTermAndCondition()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async eggPrivacyNotice() {
      try {
        var { result } = await api.eggPrivacyNotice({
          pageid: this.selectedBot.pageid
        })

        this.privacy_notice = result.data
      } catch (error) {
        console.error(error)
      }
    },

    async eggTermAndCondition() {
      try {
        var { result } = await api.eggTermAndCondition({
          pageid: this.selectedBot.pageid
        })

        this.term_and_condition = result.data
      } catch (error) {
        console.error(error)
      }
    },
    eggPageConfig() {
      return new Promise((resolve, reject) => {
        api.eggPageConfig(
          {
            pageid: this.selectedBot.pageid
          },
          (error, response) => {
            if (error) {
              reject(error)
            }
            if (response) {
              if (response.result.egg_crm.email) {
                this.step = 2
                this.egg_status = response.result.egg_crm.status
                this.bypass_url = response.result.bypass_url
                resolve(response)
              } else {
                this.step = 1
              }
            }
          }
        )
      })
    },

    async submitRegister() {
      var result = await this.$validator.validateAll()
      if (result) {
        this.$store.dispatch('loading')
        var data = {
          params: {
            pageid: this.selectedBot.pageid
          },
          body: this.registerData
        }
        return new Promise((resolve, reject) => {
          api.eggCreateMerchant(data, (error, response) => {
            if (error) {
              this.showDialog = false
              this.$swal.fire({
                title: response.data.result.message,
                type: 'error',
                confirmButtonText: this.$t('Confirm'),
                reverseButtons: true
              })
              reject(error)
              this.$store.dispatch('loading')
            }
            if (response) {
              this.$store.dispatch('loading')
              if (response.data.success) {
                this.showDialog = false
                this.eggPageConfig()
                resolve(response)
              } else {
                this.$swal.fire({
                  title: response.data.result.message,
                  type: 'error',
                  confirmButtonText: this.$t('Confirm'),
                  reverseButtons: true
                })
              }
            }
          })
        })
      }
    },
    toggleStatus() {
      if (document.getElementById('clickedid').checked === false) {
        this.$swal
          .fire({
            title: this.$t('คุณต้องการที่จะปิดการเชื่อมต่อนี้หรือไม่?'),
            text: this.$t(
              'คำเตือน!! ถ้าหากคุณต้องการปิดการเชื่อมต่อระหว่าง Zwiz และ Egg Digital อย่าลืมลบปุ่มที่มีการเชื่อมไปยังการแลกรางวัลทั้งในส่วนของข้อความต้องรับ และบทสนทนา'
            ),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })
          .then(result => {
            if (result.value) {
              this.apiToggleStatus()
            } else {
              document.getElementById('clickedid').checked = true
            }
          })
      } else {
        this.apiToggleStatus()
      }
    },
    apiToggleStatus() {
      this.$store.dispatch('loading')
      var data = {
        params: {
          pageid: this.selectedBot.pageid
        },
        body: {
          status: (this.egg_status = !this.egg_status)
        }
      }
      return new Promise((resolve, reject) => {
        api.updateStatusEggPageConfig(data, (error, response) => {
          if (error) {
            reject(error)
          }
          if (response) {
            if (response.result.egg_crm.status) {
              this.egg_status = response.result.egg_crm.status
              resolve(response)
            }
          }
          this.$store.dispatch('loading')
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/EggDigital.vue